import { request } from '@/assets/js/api/_helpers'


const ENDPOINT_REPORT = '/api/requests/private/report'


export default {
    list: (config) => request( 'GET', ENDPOINT_REPORT, config),
}